import BaseView from "./_BaseView";
import LineGraph from "../graphs/LineGraph";
import Table from "../components/Table";

export default class PageAnalyticsView extends BaseView {

    init() {
        super.init();

        if ($('#pageAnalytics').length > 0) {
            LineGraph({
                container: '#pageAnalytics',
                svg: '.pageanalytics',
                counter: Lang.pageviews.toLocaleLowerCase(),
                curved: true,
                filled: true,
                yLabel: Lang.pageviews
            });
        }

        if ($('#pageAnalyticsTable').length > 0) {
            const url = `/api/analytics/pageanalytics?daterange=${$('[name="daterange"]').val()}&path=${$('input[name="page"]').val()}`;
            this.table = new Table('pageAnalyticsTable', url, [
                {data: 'name'},
                {data: 'userid', orderable: true},
                {data: 'date'},
                {data: 'count', orderable: true},
            ]);
        }
    }

    setEvents() {
        super.setEvents();
        const self = this;
        if ($('#pageAnalytics').length > 0) {
            $('[name="daterange"]').on('change', function () {
                $('.period').text($('select[name="daterange"] option:selected').text());
                self.table.table.ajax.url(
                    '/api/analytics/pageanalytics' +
                    `?daterange=${$('[name="daterange"]').val()}` +
                    `&path=${$('input[name="page"]').val()}&app=${$('[data-app]').data('app')}`);
                self.table.reload();
            });
        }
    }
}
